import React from 'react'
 import { Card } from "react-bootstrap";

import styles from './RiskHealthCard.module.scss';
import RadialChart from "../../../../assets/images/temp/RadialChart.svg";
import LineChart from "../../../../assets/images/temp/LineChart.svg";

export default function RiskHealthCard() {
    return (
      <Card className="card-glass mb-3">
        <div className="row d-flex align-items-center">
          <div className="col-md-3">
            <img className="fw" src={RadialChart} alt="RadialChart" />
          </div>
          <div className="col-md-9">
            <img className="fw" src={LineChart} alt="RadialChart" />
          </div>
        </div>
      </Card>
    );
}
